'use client'

import { HeaderNotSignedInUser } from '@/components/header-not-signed-user'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Footer } from '@/components/footer'
import { useEffect, useState } from 'react'

export function UnauthenticatedLayout({ children }: { children: React.ReactNode }) {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    // Set a small delay to ensure content is rendered
    const timer = setTimeout(() => {
      setIsLoaded(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <TooltipProvider>
        <HeaderNotSignedInUser className="fixed md:sticky top-0 safe-top" />
        <div className="flex flex-col min-h-screen">
          <div className="flex-grow">{children}</div>
          <div className={`transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
            <Footer />
          </div>
        </div>
      </TooltipProvider>
    </>
  )
} 